export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';
